export const enum eAdState {
    none,
    loading,
    ready,
    playing,
}


export const enum eAdMode {
    videoReward,
    videoSkippable,
}



export const enum eAdShowRes {
    success,
    skipped,
    failed
}



export const enum eSDKType {
    OK,
    VK
}



export abstract class SDKBase {
    /**
     * (RO) Typ SDK
     */
    get type(): eSDKType { return this._type; }
    protected _type: eSDKType;

    /**
     * (RO) True, pokud je SDK inicializovano
     */
    get initialized(): boolean { return this._initialized; }
    protected _initialized: boolean;

    protected _adState: eAdState[];
    protected _adCallbackPar: any;

    get eventHandler(): pc.EventHandler { return this._eventHandler; }
    protected _eventHandler: pc.EventHandler;

    /**
     * Udalost vyvolana po dokonceni inicializace SDK
     * Emitter: pc.Application
     * Parametry:
     * res: boolean
     */
    static readonly EVENT_INITIALIZED = "SDK:init";

    /**
     * Udalost vyvolana po dokonceni zobrazeni reklamy
     * Emitter: pc.Application
     * Parametry:
     * res: eAdShowRes
     * callbackPar: any
     */
    static readonly EVENT_AD_COMPLETE = "SDK:adComplete";

    protected _api: any;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(app: pc.Application, type: eSDKType) {
        this._eventHandler = app;
        this._type = type;
        this._initialized = false;

        this._adState = [];
        this._adState[eAdMode.videoReward] = eAdState.none;
        this._adState[eAdMode.videoSkippable] = eAdState.none;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    abstract init(par?: any): void;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getAdState(adMode: eAdMode): eAdState {
        return this._adState[adMode];
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    loadAd(adMode: eAdMode): boolean {
        if (!this._initialized || this._adState[adMode] != eAdState.none)
            return false;

        this._adState[adMode] = eAdState.loading;
        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showAd(adMode: eAdMode, callbackPar: any): boolean {
        if (this._adState[adMode] != eAdState.ready) {
            this._eventHandler.fire(SDKBase.EVENT_AD_COMPLETE, eAdShowRes.failed, callbackPar);
            return false;
        }

        this._adCallbackPar = callbackPar;
        this._adState[adMode] = eAdState.playing;

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    abstract showInvite(par: any): void;
}
